import React from 'react';

export default function InlineLoader({ size = 'md', text }) {
  return (
    <div className="flex items-center justify-center gap-3" style={{ padding: 16 }}>
      <span className={size === 'lg' ? 'spinner spinner-lg' : 'spinner'} />
      {text && <span className="text-dim mono" style={{ fontSize: 12, letterSpacing: 1 }}>{text}</span>}
    </div>
  );
}
